module.exports = "<lp2-login-page></lp2-login-page>";


//////////////////
// WEBPACK FOOTER
// ./js/login/templates/AngularLoginContent.html
// module id = 1869
// module chunks = 15